(() => {
  const cleanText = (value) => (value || '')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const extractStage = (value) => {
    const text = cleanText(value);
    if (!text) return '';

    if (/\b(?:fresh(?:ly)?\s+)?germinated\s+seed(?:s)?\b/i.test(text)) return 'Germinated Seed';
    if (/\bfresh\s+seed(?:s)?\b/i.test(text)) return 'Fresh Seed';
    if (/\bestablished\s+(?:plant|seedling)\b/i.test(text)) return 'Established Plant';
    if (/\bstarter\s+plant\b/i.test(text)) return 'Starter Plant';

    const range = text.match(/\b(\d+)\s*[–-]\s*(\d+)\s+leaf\b/i);
    if (range) {
      const tail = text.slice((range.index || 0) + range[0].length, (range.index || 0) + range[0].length + 90);
      const kind = tail.match(/\b(seedling|seedlings|sprout|sprouts)\b/i);
      const kindLabel = kind ? (/sprout/i.test(kind[1]) ? 'Sprout' : 'Seedling') : '';
      return `${range[1]}–${range[2]} Leaf${kindLabel ? ` ${kindLabel}` : ''}`;
    }

    const oneLeaf = text.match(/\b(?:one|1)\s*[- ]?\s*leaf\b/i);
    if (oneLeaf) {
      const tail = text.slice((oneLeaf.index || 0) + oneLeaf[0].length, (oneLeaf.index || 0) + oneLeaf[0].length + 90);
      const kind = tail.match(/\b(seedling|seedlings|sprout|sprouts)\b/i);
      const kindLabel = kind ? (/sprout/i.test(kind[1]) ? 'Sprout' : 'Seedling') : '';
      return `One-Leaf${kindLabel ? ` ${kindLabel}` : ''}`;
    }

    const single = text.match(/\b(\d+)\s+leaf\b/i);
    if (single) {
      const tail = text.slice((single.index || 0) + single[0].length, (single.index || 0) + single[0].length + 90);
      const kind = tail.match(/\b(seedling|seedlings|sprout|sprouts)\b/i);
      const kindLabel = kind ? (/sprout/i.test(kind[1]) ? 'Sprout' : 'Seedling') : '';
      return `${single[1]} Leaf${kindLabel ? ` ${kindLabel}` : ''}`;
    }

    return '';
  };

  const addStage = () => {
    const content = document.querySelector('[data-jiggy-archive-content]');
    if (!content || content.querySelector('.jiggy-archive__stage')) return;

    let stage = '';
    [...content.querySelectorAll('p')].slice(0, 4).some((paragraph) => {
      stage = extractStage(paragraph.textContent);
      return Boolean(stage);
    });
    if (!stage) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'jiggy-archive__stage';

    const label = document.createElement('span');
    label.className = 'jiggy-archive__stage-label';
    label.textContent = 'GROWTH STAGE';

    const value = document.createElement('span');
    value.className = 'jiggy-archive__stage-value';
    value.textContent = stage;

    wrapper.append(label, value);
    content.prepend(wrapper);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addStage, { once: true });
  } else {
    addStage();
  }
})();
